import { environment } from "../../config/environment";

const handleLogin = async (loginUrl: string, registerUrl: string) => {
  let wnd = window as any;
  return wnd.vf.$prepublish(
    (channel: string, event: string, ...args: any[]) => {
      if (
        channel === "authentication" &&
        event === "required" &&
        args[0].method === "signup"
      ) {
        const eventAction = "VF_Registration";
        const language = "en";
        const payload = {
          "data-eventAction": eventAction,
          "data-language": language,
        };
        const event = new CustomEvent("embed_component_load", {
          detail: payload,
        });
        window.dispatchEvent(event);
        wnd.location.href = registerUrl;
        return false;
      } else if (channel === "authentication" && event === "required") {
        const eventAction = "VF_LogIn";
        const language = "en";
        const payload = {
          "data-eventAction": eventAction,
          "data-language": language,
        };
        const event = new CustomEvent("embed_component_load", {
          detail: payload,
        });
        window.dispatchEvent(event);
        wnd.location.href = loginUrl;
        return false;
      } else {
        return { channel, event, args };
      }
    }
  );
};

const handleOIDCSession = async (idToken: string) => {
  let wnd = window as any;
  if (idToken) {
    return wnd.vf.session.login.openIdConnect(idToken);
  }
};

const handleLogout = async (logoutUrl: string) => {
  let wnd = window as any;
  return wnd.vf.$subscribe("authentication", "logout", () => {
    const eventAction = "VF_LogOut";
    const language = "en";
    const payload = {
      "data-eventAction": eventAction,
      "data-language": language,
    };
    const event = new CustomEvent("embed_component_load", {
      detail: payload,
    });
    window.dispatchEvent(event);
    localStorage.clear();
    sessionStorage.clear();
    clearRewardsCookie();
    wnd.vf.session.logout();
    wnd.location.href = logoutUrl;
  });
};

const clearRewardsCookie = (): void => {
  document.cookie =
    "rewards_cookie=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;";
  document.cookie =
    "aarp_rewards_balance=;domain=.aarp.org;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
};

const handleReset = async () => {
  let wnd = window as any;
  if (wnd.vf && wnd.vf.context) {
    return wnd.vf.context.reset();
  }
};

const handleComment = async () => {
  let wnd = window as any;
  return wnd.vf.$subscribe("commenting", "loaded", (el: any) => {
    const signupButton = el.querySelector(
      ".vf-post-form__sign-up-action.vf-button"
    );
    const registerText = wnd.AARP.Everywhere.isSpanish
      ? "Regístrate"
      : "Register";
    signupButton && (signupButton.innerText = registerText);
  });
};

const addStateParamToUrl = (url: string) => {
  const splitUrl = url.split("?");
  const urlPath = splitUrl[0];
  const queryParams = splitUrl[1];
  const currentUrl = window.location.href.split("?")[0];
  const encodedReferrer = encodeURIComponent(currentUrl);
  const hasAuthParams = queryParams && queryParams.indexOf("redirect_uri") > -1;

  if (hasAuthParams) {
    let paramObj = reduceQueryToParamObj(queryParams);
    let newQuery: string;
    if (paramObj["scope"].indexOf("openid")) {
      paramObj["scope"] += "+openid";
    }
    paramObj["state"] = encodedReferrer;
    newQuery = createQueryFromParamObj(paramObj);
    return urlPath + newQuery;
  } else {
    if (url.indexOf("?") > -1) {
      return url + "&referrer=" + encodedReferrer;
    } else {
      return url + "?referrer=" + encodedReferrer;
    }
  }
};
const reduceQueryToParamObj = (queryParams: string) => {
  const paramArray = queryParams.split("&");
  let paramObj = {};
  paramArray.forEach((element) => {
    const keyValues = element.split("=");
    const key = keyValues[0];
    const value = keyValues[1];

    paramObj[key] = value;
  });
  return paramObj;
};
const createQueryFromParamObj = (paramObj: any) => {
  let queryString = "?";
  for (var key of Object.keys(paramObj)) {
    if (queryString != "?") {
      queryString += "&";
    }
    queryString += key + "=" + paramObj[key];
  }
  return queryString;
};

const modifyIntcmpParam = (url: string) => {
  const splitUrl = url.split("?");
  const urlPath = splitUrl[0];
  const queryParams = splitUrl[1];

  let paramObj = reduceQueryToParamObj(queryParams);

  let newIntcmpValue = "";
  if (urlPath.includes("secure.aarp.org")) {
    newIntcmpValue = "GAM-VF-REG";
  } else {
    newIntcmpValue = "GAM-VF-REG-STG";
  }

  if (paramObj["intcmp"]) {
    paramObj["intcmp"] = newIntcmpValue;
  }

  let newQuery = createQueryFromParamObj(paramObj);

  return urlPath + newQuery;
};

interface VFOpenIDConnectProps {
  idToken: string;
}

export const vfOpenIDConnect = ({ idToken }: VFOpenIDConnectProps): void => {
  let wnd = window as any;
  wnd.AARP = (window as any).AARP || {};
  wnd.AARP.Everywhere = wnd.AARP.Everywhere || {};

  const setURL = (type: 'login' | 'logout' | 'register', base: string, queryParams: string, logoutPath: string = '') => {
    return `${base}${type === 'logout' ? logoutPath : ''}?${queryParams}`;
  };

  const queryParams = 'promo=GAMESCUST&dyr=true';
  const base = { login: environment.AARP_LOGIN_BASE, logout: environment.AARP_LOGOUT_BASE, register: environment.AARP_REGISTER_BASE };
  wnd.AARP.Everywhere.loginUrl = setURL('login', base.login, `${queryParams}&intcmp=DSO-HDR-GAMES-LOGIN`);
  wnd.AARP.Everywhere.logoutUrl = setURL('logout', base.logout, 'intcmp=GLOBAL-HDR-LNK-CLK-DD-LOGOUT-UXDIA', '/logout');
  wnd.AARP.Everywhere.registerUrl = setURL('register', base.register, `${queryParams}&intcmp=DSO-HDR-GAMES-REG`);

  const loginUrl = addStateParamToUrl(wnd.AARP.Everywhere.loginUrl);
  const logoutUrl = addStateParamToUrl(
    wnd.AARP.Everywhere.logoutUrl
  );
  const registerUrl = addStateParamToUrl(
    wnd.AARP.Everywhere.registerUrl
  );
  const registerUrlWithUpdatedIntcmp = modifyIntcmpParam(registerUrl);
  wnd.vfQ = wnd.vfQ || [];
  wnd.vfQ.push(async () => {
    await handleLogin(loginUrl, registerUrlWithUpdatedIntcmp);
    await handleOIDCSession(idToken);
    await handleLogout(logoutUrl);
    await handleComment();
    await handleReset();
  });
};